<template>
    <div class="slider-wrap" @click="onClick">
        <div class="process" :style="`width:${model}%`"></div>
        <div class="total"></div>
        <div
            class="slider"
            :style="`left:${model}%`"
            @touchstart="onTouchStart"
            @touchend="onTouchEnd"
        ></div>
    </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Number,
  },
  computed: {
    model() {
      return Math.max(0, Math.min(this.value, 100));
    },
  },
  created() {
    this.onTouchMove = this.onTouchMove.bind(this);
  },
  mounted() {
    const el = document.querySelector('.slider-wrap');
    const { x, width } = el.getBoundingClientRect();
    this.min = x;
    this.max = x + width;
    this.total = width;
  },
  methods: {
    onTouchStart(e) {
      if (e.preventDefault && e.cancelable) e.preventDefault();
      window.addEventListener('touchmove', this.onTouchMove);
    },
    onTouchMove(e) {
      const clientX = e.changedTouches?.[0]?.clientX || 0;
      this.emitVal(clientX);
    },
    onTouchEnd() {
      window.removeEventListener('touchmove', this.onTouchMove);
    },
    onClick(e) {
      if (e.x) this.emitVal(e.x);
    },
    emitVal(clientX) {
      const x = Math.max(Math.min(clientX, this.max), this.min);
      const percent = ((x - this.min) / this.total) * 100;
      if (percent === this.value) {
        return;
      }
      this.$emit('change', percent);
    },
  },
};
</script>

<style lang="less" scoped>
.slider-wrap{
    width: 260px;
    padding: 8px 0;
    margin: 0 auto;
    position: relative;
    .total {
        width: 100%;
        height: 8px;
        border-radius: 4px;
        background-color: rgba(59, 220, 188, .3);;
    }
    .process {
        position: absolute;
        z-index: 10;
        left: 0;
        top: 8px;
        height: 8px;
        border-radius: 4px;
        background-color: rgba(59, 220, 188, 1);
    }
    .slider {
        position: absolute;
        z-index: 20;
        top: 0;
        transform: translate3d(-50%, 0, 0);
        width: 10px;
        height: 24px;
        background-color: #fff;
        border-radius: 2px;
    }
}
</style>
